document
	.querySelectorAll("[data-combined-listing-media-alt]")
	.forEach((combinedListingImage) => {
		combinedListingImage.addEventListener("mouseenter", function () {
			this.click();
		});
	});

document
	.querySelectorAll("[data-combined-listing-media-id]")
	.forEach((combinedListingImage) => {
		combinedListingImage.addEventListener("mouseenter", function () {
			const mediaId = this.getAttribute("data-combined-listing-media-id");
			document
				.querySelector(
					`[data-combined-listing-media-alt][data-media-id='${mediaId}']`
				)
				.click();
		});
	});
